import React, { Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Moment from "react-moment";

const JobItem = ({
  post: {
    _id,
    channelid,
    companyname,
    avatar,
    jobtitle,
    location,
    environment,
    employmenttype,
    salary,
    keywords,
    jobdescription,
    jobsummary,
    responsibilities,
    qualifications,
    benefits,
    comments,
    vrtour,
    jobstream,
    date,
  },
  Job,
  stateComments,
  setshowJob,
  formatter,
}) => {
  return (
    <Fragment>
      <div
        className="post-container-section"
        onClick={() =>
          setshowJob({
            ...Job,
            _id,
            channelid,
            jobtitle,
            companyname,
            location,
            employmenttype,
            salary,
            environment,
            keywords,
            jobdescription,
            jobsummary,
            responsibilities,
            qualifications,
            benefits,
            comments,
            // stateComments.map((postComments) => {
            //   postComments.map((comment) => {
            //     comments.map((postComment) => {
            //       if (postComment._id === comment._id) {
            //         return [comment];
            //       }
            //     });
            //   });
            // }),
            vrtour,
            jobstream,
            date,
            avatar,
          })
        }
      >
        <div className="post-section-info-container">
          <div className="flex-start">
            <ul>
              <li className="post-job-title">{jobtitle}</li>
              <li className="job-post-li">{companyname}</li>
              <li className="job-post-li">
                {location.city}, {location.state}
              </li>
              <ul>
                <li className="job-post-keywords">
                  <i className="fas fa-business-time mr-5"></i>
                  {employmenttype}
                </li>
                {salary === 0 ? (
                  <li className="job-post-keywords">
                    <i className="far fa-money-bill-alt mr-5"></i>
                    Salary Not Available
                  </li>
                ) : (
                  <li className="job-post-keywords">
                    <i className="far fa-money-bill-alt mr-5"></i>
                    {formatter.format(salary)}
                  </li>
                )}
                <li className="job-post-keywords">
                  <i className="far fa-building mr-5"></i>
                  {environment}
                </li>
              </ul>
              {vrtour !== "" && (
                <li className="keywords-job-post black">
                  <i className="fas fa-street-view fa-sm black times-sm mx-10"></i>
                </li>
              )}
              {jobstream !== "" && (
                <li className="keywords-job-post black">
                  <i className="fas fa-video fa-sm black times-sm mx-10"></i>
                </li>
              )}
              <li className="job-post-li">
                <i className="far fa-clock bold fa-sm black times-sm mr-5"></i>
                <Moment format="MM/DD/YYYY">{date}</Moment>
              </li>
            </ul>
          </div>
        </div>
        <div className="setting-friends-buttons-container">
          <div className="flex-end">
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
              className="job-post-image"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

JobItem.propTypes = {
  post: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(JobItem);
